import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema5/GLB_Caja Registradora_V2.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Caja extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.35, -1.07, -2.2);
		this.scale.set(3, 3, 3);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Caja = gltf.scene.getObjectByName("Registradora_Base", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const CajaFolder = gui.addFolder("Caja");
		CajaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		CajaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		CajaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		CajaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		CajaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		CajaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		CajaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		CajaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		CajaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		CajaFolder.add(this, "visible").name("visible");
	}
	onAnimateCaja() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.Caja
		this.Caja.material.emissive.set("#404040");

		this.animation = gsap.to(this.Caja.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
}